var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(90 24.5 0)",
    fill: "#006DB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 17.7262L13.33 8.04626L15.7089 10.1631C16.0311 10.4497 16.5515 10.4497 16.8736 10.1631C17.1958 9.8764 17.1958 9.41336 16.8736 9.12671L13.0822 5.75307C12.76 5.46642 12.2397 5.46642 11.9175 5.75307L8.12608 9.12671C7.80393 9.41335 7.80393 9.8764 8.12608 10.1631C8.44822 10.4497 8.96862 10.4497 9.29076 10.1631L11.678 8.04626L11.678 17.7262C11.678 18.1304 12.0497 18.4612 12.504 18.4612C12.9583 18.4612 13.33 18.1304 13.33 17.7262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowRounded);
export default __webpack_public_path__ + "static/media/up-arrow-rounded.72526b36d152ed06387b23958a81459a.svg";
export { ForwardRef as ReactComponent };